import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseUrl } from 'src/environments/environment';
import { Country } from '../_models/country.mode';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  // countryUrl =  'api/Cities';
  countries: Country[] = [{ id: 1, name: 'Egypt' }];

  constructor(private http: HttpClient) {}

  getAllCountries(): Country[] {
    return this.countries;
  }
}
